import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'tasksTypes',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.tasksTypes.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: ({results}) => Object.keys(results).map(key => ({
            ...results[key]
        }))
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/tasksTypes.js